/* eslint-disable no-shadow,no-param-reassign */
const initialState = {
  practice: {
    id: null,
    logo: "",
    name: ""
  }
};

export const state = initialState;

export const getters = {};

export const actions = {
  setPractice({ commit }, payload) {
    commit("setPractice", payload);
  }
};

export const mutations = {
  setPractice(state, practice) {
    state.practice = practice;
  }
};
